// extracted by mini-css-extract-plugin
export default {"image":"Projetos_image__pNDt3","grid3Item":"Projetos_grid3Item__A3vnV","grid3":"Projetos_grid3__BeQy3","p":"Projetos_p__4mzaF","link":"Projetos_link__BcSG9"};